export function SyncWizardBoardIcon({ color }: { color: string }) {
  return (
    <svg width="18" height="15" viewBox="0 0 13.6 11.2" fill="none">
      <path
        clipRule="evenodd"
        d="M0 1.6C0 0.716344 0.761116 0 1.7 0H11.9C12.8389 0 13.6 0.716344 13.6 1.6V9.6C13.6 10.4837 12.8389 11.2 11.9 11.2H1.7C0.761116 11.2 0 10.4837 0 9.6V1.6ZM4.675 1.2H11.9C12.1347 1.2 12.325 1.37909 12.325 1.6V9.6C12.325 9.82091 12.1347 10 11.9 10H4.675L4.675 1.2ZM3.4 1.2H1.7C1.46528 1.2 1.275 1.37909 1.275 1.6V9.6C1.275 9.82091 1.46528 10 1.7 10H3.4L3.4 1.2Z"
        fill={color}
        fillRule="evenodd"
      />
    </svg>
  );
}
